export default __webpack_public_path__ + "e0db8d67054de1d5e020b6c0c5587630.webp";